<!-- 机构抽题 -->
<template>
    <div class="rg-sam">
        <div class="xy-start flex-wrap">
            <div class="xy-center jf-start item flex-wrap">
                <el-cascader :options="chooseQuesOptions" :props="{ emitPath: false }" v-model="currentChoose" style="margin-right: 20px"/>
                <el-select v-model="queInfo.type" placeholder="请选择试题类别" clearable>
                    <el-option
                        v-for="item in organClass"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                        <div
                            :style="{
                                paddingLeft: `${item.parentIds.length * 30}px`
                            }"
                        >
                            {{ item.label }}
                        </div>
                    </el-option>
                </el-select>
                <el-select
                    v-model="queInfo.queType"
                    placeholder="请选择题型"
                    clearable
                    style="margin-left:20px;"
                >
                    <el-option
                        v-for="item in queTypeData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>

                <el-select
                    v-model="queInfo.difficulty"
                    placeholder="请选择试题难度"
                    clearable
                    style="margin-left:20px;"
                >
                    <el-option
                        v-for="item in difficultyData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>

                <el-select
                    v-model="queInfo.useFor"
                    placeholder="请选择试题用途"
                    clearable
                    style="margin-left:20px;"
                >
                    <el-option
                        v-for="item in useForData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>

                <el-input
                    v-model="queInfo.searchKey"
                    class="search"
                    placeholder="请输入试题关键字检索..."
                    style="width:220px;margin-left:20px;"
                >
                    <template slot="append"
                        ><div @click="goSearch" class="pointer">
                            检索
                        </div></template
                    >
                </el-input>
            </div>
            <!-- <div class="xy-center jf-start item">
                <div class="name">题型:</div>
                <el-select
                    v-model="queInfo.queType"
                    placeholder="请选择题型"
                    clearable
                >
                    <el-option
                        v-for="item in queTypeData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div> -->
            <!-- <div class="xy-center jf-start item">
                <div class="name">难度:</div>
                <el-select
                    v-model="queInfo.difficulty"
                    placeholder="请选择试题难度"
                >
                    <el-option
                        v-for="item in difficultyData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div> -->
            <!-- <div class="xy-center jf-start item">
                <div class="name">用途:</div>
                <el-select
                    v-model="queInfo.useFor"
                    placeholder="请选择试题用途"
                    clearable
                >
                    <el-option
                        v-for="item in useForData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div> -->
            <!-- <el-input
                v-model="queInfo.searchKey"
                class="item search"
                placeholder="请输入试题关键字检索..."
            >
                <template slot="append"
                    ><div @click="goSearch" class="pointer">检索</div></template
                >
            </el-input> -->
        </div>
        <div v-show="currentChoose === 'custom'">
            <el-table
                :data="tableData"
                height="400"
                border
                style="width: 100%"
                class="el-table"
                v-loading="flag.loading"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="Content"
                    label="试题"
                    align="center"
                    show-overflow-tooltip
                >
                    <template v-slot="scoped">
                        <table-que :data="scoped.row"></table-que>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="ClassId"
                    label="所属分类"
                    width="120"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    organClass.find(
                                        (item) => item.value === scoped.row.ClassId
                                    ) || {}
                                ).label
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="SubjectType"
                    label="题型"
                    width="70"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    queTypeData.find(
                                        (item) =>
                                            item.value === scoped.row.SubjectType
                                    ) || {}
                                ).name
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="Hardlevel"
                    label="难易度"
                    width="70"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    difficultyData.find(
                                        (item) =>
                                            item.value === scoped.row.Hardlevel
                                    ) || {}
                                ).name
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="AddUserName"
                    label="创建人"
                    width="100"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="AddTime"
                    label="创建时间"
                    width="100"
                    align="center"
                >
                    <template v-slot="scoped"
                    >{{ scoped.row.AddTime.substring(0, 10) }}
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination xy-center mt-15">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="count"
                >
                </el-pagination>
            </div>
        </div>
       <div v-show="currentChoose === 'random'">
           <choose-ques v-model="quesNum" :ques-num="totalCount"/>
       </div>
    </div>
</template>

<script>
import ChooseQues from "../ChooseQues";
import { CommonPage } from "@/mixins/commonData";
import { GetOrganClassLit } from "@/api/questionPaper.js";
import { organSampling, queSampling } from "@/api/manage.js";
import tableQue from "../tableQue.vue";
import { getChooseQuesType } from "./config";
import { random } from "lodash";
export default {
    components: { tableQue, ChooseQues },
    mixins: [CommonPage],
    data() {
        return {
            queInfo: {
                type: "",
                queType: "",
                difficulty: "",
                useFor: "",
                searchKey: ""
            },
            quesNum: 1,
            chooseQuesOptions: getChooseQuesType(),
            organClass: [],
            flag: {
                loading: false
            },
            tableData: [],
            count: 0,
            currentPage: 1,
            pageSize: 10,
            multipleSelection: [],
            currentChoose: "custom",
            totalCount: 0
        };
    },
    mounted() {
        this.fetchOrganClass();
        this.fetchList();
        this.getOrgQues()
    },
    methods: {
        fetchOrganClass() {
            GetOrganClassLit().then((res) => {
                const data = res.data.data;
                // console.log("data:", data);
                let newData = [];
                const work = (vl, pIds) => {
                    for (let i = 0; i < vl.length; i++) {
                        newData.push({
                            label: vl[i].label,
                            value: vl[i].value,
                            parentIds: pIds
                        });
                        if (vl[i].children.length) {
                            work(vl[i].children, pIds.concat([vl[i].value]));
                        }
                    }
                };
                work(data, []);
                // console.log("newData:", newData);
                this.organClass = newData;
            });
        },
        fetchList() {
            this.flagPromise([
                organSampling({
                    classId: this.queInfo.type,
                    subType: this.queInfo.queType,
                    hardLevel: this.queInfo.difficulty,
                    useType: this.queInfo.useFor,
                    searchKey: this.queInfo.searchKey,
                    pageno: this.currentPage,
                    pagesize: this.pageSize
                })
            ]).then(([res]) => {
                this.count = res.data.count;
                this.tableData = res.data.data;
            });
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchList();
            console.log(`当前页: ${val}`);
        },
        goSearch() {
            this.currentPage = 1;
            this.fetchList();
            this.getOrgQues()
        },
        handleSelectionChange(val) {
            console.log("val:", val);
            this.multipleSelection = val;
        },
        getOrgQues () {
            this.flagPromise([
                queSampling({
                    classId: this.queInfo.type,
                    subType: this.queInfo.queType,
                    hardLevel: this.queInfo.difficulty,
                    useType: this.queInfo.useFor
                })
            ]).then(([res]) => {
                this.totalCount = res.data.count;
                this.dataList = res.data.data;
                this.quesNum = Math.min(1, res.data.count)
                // console.log("res:", res);
            });
        },
        getQuestionList () {
            if (this.currentChoose === "custom") {
                return this.multipleSelection
            } else {
                const copy = Array.isArray(this.dataList) && this.dataList.length > 0 ? [...this.dataList] : [];
                if (copy.length > 0) {
                    const result = [];
                    for (let i = 0; i < this.quesNum; i++) {
                        const index = random(0, copy.length - 1, false)
                        result.push(...copy.splice(index, 1));
                    }
                    return result
                } else {
                    return []
                }
            }
        }
    }
};
</script>

<style lang="less" scoped>
.rg-sam::v-deep {
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;

    .item {
        margin-top: 30px;
        .name {
            white-space: nowrap;
            width: 4.5em;
            font-size: 16px;
            text-align: right;
            box-sizing: border-box;
        }
    }
    .el-input {
        width: 180px;
        height: 35px;

        input {
            height: 35px;
            width: 180px;

            ::placeholder {
                font-size: 16px;
            }
        }
    }

    .search {
        width: 300px;
        box-sizing: border-box;
        .el-input-group__append {
            background: #1677ff;
            color: white;
            border-color: #1677ff;
        }
    }

    .el-table {
        margin-top: 30px;
    }
}
</style>
